import { connect } from 'react-redux';
import SearchMenu from './search-menu.component';
import { updateEBookDataRoutine } from "redux-state/ducks/player";

const mapStateToProps = ({ }) => ({ });

const mapDispatchToProps = {
  updateEBookDataAction: updateEBookDataRoutine.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchMenu);
